import { ComponentProps } from "react";
import { Options, Splide, SplideSlide } from "@greglaisph/react-splide";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

import "@greglaisph/react-splide/css";
import styles from "@pages/MBO/styles/MboSlider.module.css";

export type MboSliderCarouselProps = {
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
};

const MboSliderCarousel = ({
  cardProps,
}: MboSliderCarouselProps): React.ReactElement => {
  const cardVariant: CardVariations = {
    image: {
      position: "left",
      width: styles.mboImage,
    },
    content: {
      width: styles.mboHeadline,
      extraClass: cn("bg-white text-gray-850"),
    },
    title: {
      size: styles.mboHeadlineLink,
      color: "text-gray-850",
      extraClass: "font-lct",
    },
  };
  const options: Options = {
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: false,
    snap: true,
    type: "loop",
    autoHeight: true,
    autoplay: true,
  };

  return (
    <div className="relative" data-testid="mbo-carousel-list">
      <Splide options={options}>
        {cardProps.map((cardProp) => {
          return (
            <SplideSlide
              className="h-auto w-full"
              key={cardProp.id}
              data-testid={`title_link_${cardProp.id}`}
            >
              <Card
                {...cardProp}
                variations={cardVariant}
                className={cn({
                  "text-center": !cardProp.media,
                })}
              />
            </SplideSlide>
          );
        })}

        <ul
          className={cn(
            "splide__pagination podcast-featured-carousel",
            "lg:!left-[unset] lg:right-0 lg:w-5/12",
            "xl:w-4/12"
          )}
        ></ul>
      </Splide>
    </div>
  );
};

export default MboSliderCarousel;
